import { memo, useState, useEffect } from 'react';
import { isChristmasSeason, isNewYearSeason, isEasterSeason } from './index';

/**
 * Christmas background image for page headers
 * Shows Christmas decoration (Dec 15-26)
 */
function BackgroundChristmas(props) {
  return (
    <img
      src="assets/images/special/christmas.svg"
      alt="Christmas decoration"
      style={{
        width: '100%',
        height: '195px',
        objectFit: 'contain',
        objectPosition: 'top',
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
      }}
      {...props}
    />
  );
}

/**
 * New Year background image for page headers
 * Shows New Year decoration (Dec 27 - Jan 3)
 */
function BackgroundNewYear(props) {
  return (
    <img
      src="assets/images/special/newyear2026.svg"
      alt="New Year decoration"
      style={{
        width: '100%',
        height: '256px',
        objectFit: 'contain',
        objectPosition: 'top',
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
      }}
      {...props}
    />
  );
}

/**
 * Easter background image for page headers
 * Shows Easter decoration (Good Friday - Easter Monday)
 */
function BackgroundEaster(props) {
  return (
    <img
      src="assets/images/special/easter.svg"
      alt="Easter decoration"
      style={{
        width: '100%',
        height: '220px',
        objectFit: 'contain',
        objectPosition: 'top',
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
      }}
      {...props}
    />
  );
}

/**
 * Large background special image for page headers
 * Shows Christmas decoration (Dec 15-26), New Year decoration (Dec 27 - Jan 3),
 * or Easter decoration (Good Friday - Easter Monday)
 * Designed to replace the background logo icons in all page headers
 */
function BackgroundSpecial(props) {
  const [showChristmas, setShowChristmas] = useState(isChristmasSeason());
  const [showNewYear, setShowNewYear] = useState(isNewYearSeason());
  const [showEaster, setShowEaster] = useState(isEasterSeason());

  // Re-check season status every minute so the decoration appears/disappears
  // without requiring a page reload when the season boundary is crossed
  useEffect(() => {
    const interval = setInterval(() => {
      setShowChristmas(isChristmasSeason());
      setShowNewYear(isNewYearSeason());
      setShowEaster(isEasterSeason());
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  if (showChristmas) {
    return <BackgroundChristmas {...props} />;
  }

  if (showNewYear) {
    return <BackgroundNewYear {...props} />;
  }

  if (showEaster) {
    return <BackgroundEaster {...props} />;
  }

  return null;
}

export const MemoizedBackgroundChristmas = memo(BackgroundChristmas);
export const MemoizedBackgroundNewYear = memo(BackgroundNewYear);
export const MemoizedBackgroundEaster = memo(BackgroundEaster);
export default memo(BackgroundSpecial);

